import { storecfg } from './appkitStore'
import { updateButtonVisibility, updateTheme } from './dom'

let runtimePromise = null
let subscribersInitialized = false

const hasRequiredBrowserFeatures = () => {
  if (typeof window === 'undefined') return false

  return typeof Promise !== 'undefined'
    && typeof BigInt === 'function'
    && typeof TextEncoder !== 'undefined'
    && typeof URL !== 'undefined'
    && Boolean(window.crypto && typeof window.crypto.getRandomValues === 'function')
}

export const getWalletRuntime = async () => {
  if (!hasRequiredBrowserFeatures()) return null

  if (!runtimePromise) {
    runtimePromise = Promise.all([
      import('./appKit'),
      import('@wagmi/core'),
    ]).then(([appKitModule, wagmiCore]) => ({
      ...wagmiCore,
      appKit: appKitModule.appKit,
      networks: appKitModule.networks,
      wagmiAdapter: appKitModule.wagmiAdapter,
    })).catch(() => {
      runtimePromise = null
      return null
    })
  }

  return runtimePromise
}

export const initializeWalletRuntime = async () => {
  const runtime = await getWalletRuntime()
  if (!runtime || subscribersInitialized) return runtime

  try {
    const { initializeSubscribers } = await import('./suscribers')
    initializeSubscribers(runtime.appKit)
    updateButtonVisibility(runtime.appKit.getIsConnectedState())
    updateTheme(storecfg.themeState.themeMode)
    subscribersInitialized = true
  } catch (error) {
    // Wallet events are optional: a subscriber failure must never block the site.
  }

  return runtime
}
